import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

const ModalDeleteMessaggioOrdineEmail = ({ isOpen, toggle, onSetEliminato, deleting, messaggio }) => {
  return(
    <Modal isOpen={isOpen} toggle={toggle} size='md'>
      <ModalHeader toggle={toggle}>Elimina messaggio ordine email</ModalHeader>
      <ModalBody>
        {messaggio &&
        <div className='container'>
          Sei sicuro di voler eliminare il messaggio {messaggio.titolo}?
        </div>
        }
      </ModalBody>
      <ModalFooter className='d-flex justify-content-between'>
        <Button color="secondary" onClick={toggle}>Chiudi</Button>
        <Button color="danger" disabled={deleting} onClick={onSetEliminato}>Elimina</Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalDeleteMessaggioOrdineEmail
